import { EnumBuilder } from '@mntn-dev/utility-types'
import type { z } from 'zod'

export const [Currencies, CurrencySchema, Currency] = EnumBuilder('USD')

export type Currency = z.infer<typeof CurrencySchema>
